import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, InputAdornment, InputLabel, MenuItem, Select, TextField, Typography } from '@material-ui/core';
import {React,useEffect,useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import usePricelist from './usePricelist';



export default function AddInvoiceDialog(props) {
    const {open,onClose,idToken,apiDomain,pricelist,customerId,customerFullname}=props;
    const defaultErrors={"comments":"","price":"","qty":"","item":""};
    const defaultValues={"comments":"","price":"","qty":1,"item":null,customer_id:customerId,customer_name:customerFullname,item_category:"",item_subcategory:"",item_subcategory_en:"",send_email:true};

    
    const [inputs,setInputs] = useState(defaultValues);
    const [errors,setErrors] = useState(defaultErrors);
    const [isSaving,setIsSaving] = useState(false);
    const [saveError,setSaveError] = useState("");
    
    useEffect(()=>{
      setInputs(inputs => ({...inputs, 'customer_id': customerId}));
      setInputs(inputs => ({...inputs, 'customer_name': customerFullname}));
    },[open]);

    const handleInputChange = (event) => {
      event.persist();
      const field=event.target.name;
      let value=event.target.value;
      if(field==="item"){
        const price=pricelist[value].price;
        const total=(inputs.qty*price).toFixed(2);
        setInputs(inputs => ({...inputs, 'price': price}));
        setInputs(inputs => ({...inputs, 'total': total}));
        setInputs(inputs => ({...inputs, 'item_category': pricelist[value].category}));
        setInputs(inputs => ({...inputs, 'item_subcategory': pricelist[value].subcategory}));
        setInputs(inputs => ({...inputs, 'item_subcategory_en': pricelist[value].subcategory_en}));
      }
      if(field==="qty" && value&& value<1){
        value=1;
      }
      if(field==="qty"){
        value=parseInt(value);
      }
      if(field==="qty"){
        const total=(value*inputs.price).toFixed(2);
        setInputs(inputs => ({...inputs, 'total': total}));
      }
      if(field==="price"){
        const total=(value*inputs.qty).toFixed(2);
        setInputs(inputs => ({...inputs, 'total': total}));
      }
      setInputs(inputs => ({...inputs, [field]: value}));
    }

    const validate = (inputs) => {
      //Email errors
     const validationErrors = {};
     
     if(inputs.item===null){
      validationErrors.item = 'Item is required'
     }
     if(!inputs.price){
      validationErrors.price = 'Price is required'+inputs.item
     }else{
       if(inputs.price<0){
        validationErrors.price = 'Invalid price'
       }
     }
     if(!inputs.qty){
      validationErrors.qty = 'People/Quantity/Hours is required'
     }
     return validationErrors;
   }

    

    const handleCancel = () => {
        onClose(null);
        resetData();
      };
    const handleClose = () => {
      onClose(null);
      };
    const resetData=()=>{
        setInputs(defaultValues);
        setErrors(defaultErrors);
        setSaveError("");
      }
    const handleSave = async (event) => {
        if(event){
          event.preventDefault();
        }
        const validationErrors = validate(inputs);
        const noErrors = Object.keys(validationErrors).length === 0;
        setErrors(validationErrors);
        if(noErrors){
          save();
        }
      }

      const save=async ()=>{
        setIsSaving(true);
        //await sleep(1000);
          const params=`/members/invoice/add/`;
          fetch(apiDomain+params,{
            "headers":{"id_token":idToken,'Content-Type': 'application/json'},
            method:"post",
            body:JSON.stringify(inputs)
          })
          .then(res => res.text())
          .then(res => JSON.parse(res))
          .then(res => {
            setIsSaving(false);
            if(res.success){
              resetData();
              onClose(res.data);
            }else{
              setSaveError(res.error);  
            }            
        } )
        .catch((error)=>{
            console.log(error);
            setSaveError(error.message);
            setIsSaving(false);
        });
      }


  
    function sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    }
    const useStyles = makeStyles((theme) => ({
        root: {
          '& .MuiTextField-root': {
            margin: theme.spacing(1),
          },
          '& .M2uiInput-root': {
            margin: theme.spacing(1),
          }},
          formControl: {
            margin: theme.spacing(1),
          },
          selectEmpty: {
            margin: theme.spacing(1),
          },
        
      }));
    const classes = useStyles();
    return (
        <div>
          <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">Create New Invoice - {customerFullname}</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Create an invoice for Academy services.
              </DialogContentText>
              <form className={classes.root} noValidate autoComplete="off">
                <FormControl className={classes.formControl} fullWidth>
                  <InputLabel>Item</InputLabel>
                  <Select name="item" onChange={handleInputChange} value={inputs.item} required fullWidth error={Boolean(errors.item)} helperText={errors.item}>
                    {pricelist
                    .map((item,index)=>{
                      return item.active&&<MenuItem key={index} value={index}>{item.subcategory_en}</MenuItem>
                    })}
                  </Select>
                </FormControl>
                <TextField name="price" onChange={handleInputChange} value={inputs.price} error={Boolean(errors.price)} helperText={errors.price} label="Price" variant="standard" type="number" required fullWidth InputProps={{startAdornment: (<InputAdornment position="start">€</InputAdornment>),}}/>
                <TextField name="qty" onChange={handleInputChange} value={inputs.qty} error={Boolean(errors.qty)} helperText={errors.qty} label="People/Quantity/Hours" variant="standard" type="number" required fullWidth/>
                <TextField name="total" onChange={handleInputChange} value={inputs.total} error={Boolean(errors.total)} helperText={errors.total} label="Total" variant="standard" type="number" required fullWidth InputProps={{readOnly:true,startAdornment: (<InputAdornment position="start">€</InputAdornment>),}}/>                              
                <TextField name="comments" onChange={handleInputChange} value={inputs.comments} error={Boolean(errors.comments)} helperText={errors.comments} label="Comments" variant="standard" fullWidth/>
              
              </form> 
              {saveError&&<DialogContentText>
                <Typography color="secondary">{saveError}</Typography>
              </DialogContentText>
              }
            </DialogContent>
            <DialogActions style={{minHeight:60}}>
              {isSaving&&<CircularProgress/>}
              <Button style={{position:'absolute',left:20}} onClick={resetData} color="secondary" size="medium" disabled={isSaving}>Reset</Button>
              <Button onClick={handleCancel} size="medium" color="primary" variant="text" disabled={isSaving}>Cancel</Button>
              <Button onClick={handleSave}  size="medium"  color="primary" variant="text" disabled={isSaving}>Save</Button>
            </DialogActions>
          </Dialog>
        </div>
      );
}